import { render, staticRenderFns } from "./InteractionMenu.vue?vue&type=template&id=81b851ac&"
import script from "./InteractionMenu.vue?vue&type=script&lang=js&"
export * from "./InteractionMenu.vue?vue&type=script&lang=js&"
import style0 from "./InteractionMenu.vue?vue&type=style&index=0&id=81b851ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports